/* Écrans de l'application. Les valeurs sont conservées telles quelles : elles sont enregistrées
   dans les préférences du navigateur (dernière vue ouverte). */
export const VIEWS = {
  TIMELINE: 'timeline',
  PROJECTS: 'projets',
  TEAM: 'devs',
  TIMESHEETS: 'timesheets',
  JIRA: 'jira',
  CRM_HOME: 'crm_accueil',
  CRM_DEALS: 'crm_affaires',
  CRM_CONTACTS: 'crm_clients',
  CRM_FINANCE: 'crm_finance',
  CRM_TENDERS: 'crm_ao',
  LEAVE: 'conges',
  PROFILE: 'profile',
} as const;

export type View = (typeof VIEWS)[keyof typeof VIEWS];
